import { $authHost } from '.';
import { GetVisitsHistoryResponse } from '@/@types/visitsHistory.types';

export async function getVisitsHistory() {
  const response = await $authHost.request<GetVisitsHistoryResponse>({
    url: '/visits_history',
  });
  return response;
}
